// extracted by mini-css-extract-plugin
export var askAiIcon = "_pf-9";
export var container = "_pf-0";
export var groupSeparator = "_pf-a";
export var highlight = "_pf-4";
export var resultIcon = "_pf-5";
export var resultItem = "_pf-7";
export var resultSubtitle = "_pf-3";
export var resultTitle = "_pf-2";
export var resultsList = "_pf-1";
export var searchGroup = "_pf-6";
export var selected = "_pf-8";